import React from "react";
import { AlertTost, CustomInput } from "#components";
import ImagesUrl from "#constants/images.js";
import { resetPasswordInitialValues } from "#validations/initialValues.js";
import { resetPasswordValidationSchema } from "#validations/validationSchema.js";
import { useFormik } from "formik";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";
import { useLocation, useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { WebRoutePath } from "#routes/routePath.jsx";
import usePost from "#hooks/usePost.js";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import toast from "react-hot-toast";

const ResetPassword = () => {
  const location = useLocation();
  const nav = useNavigate();
  const [isActive, setIsActive] = React.useState({
    password: false,
    confirmPassword: false,
  });
  const {
    mutateAsync: resetPasswordMutateAsync,
    isLoading: isLoadingResetPassword,
  } = usePost(ENDPOINTS.RESET_PASSWORD, QUERY_KEYS.RESET_PASSWORD_QUERY_KEY);
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    resetForm,
  } = useFormik({
    initialValues: resetPasswordInitialValues,
    validationSchema: resetPasswordValidationSchema,
    onSubmit: async (values) => {
      const data = {
        email: location.state,
        password: values.password,
      };
      nav(WebRoutePath.LOGIN.path);
      try {
        const response = await resetPasswordMutateAsync(data);
        if (response.status === true) {
          AlertTost("Password Reset Successfully", "success");
          resetForm();
        }
      } catch (error) {
        toast.dismiss();
        AlertTost(error?.response?.data?.message, "error");
      }
    },
  });

  function handlePasswordVisible(data) {
    setIsActive((prev) => ({
      ...prev,
      [data]: !prev[data],
    }));
  }

  return (
    <form onSubmit={handleSubmit} className="login-main">
      <div className="login-logo-main">
        <img src={ImagesUrl.loginBackground} alt="" />
      </div>
      <div
        className="login-form-main"
        data-aos="fade-right"
        data-aos-duration="1500"
      >
        <div className="login-card-item">
          <div className="inner-content">
            <div className="text-center">
              <h1 className="">Reset Password !</h1>
              <p>Please enter new password to reset</p>
            </div>

            <div className="form-main">
              <div className="form-inner-div">
                <CustomInput
                  label="New Password"
                  type={isActive.password ? "text" : "password"}
                  placeholder="Password"
                  name="password"
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.password}
                  touched={touched.password}
                />
                <div
                  onClick={() => handlePasswordVisible("password")}
                  className="password-eye"
                >
                  {isActive.password ? (
                    <MdOutlineRemoveRedEye />
                  ) : (
                    <RiEyeCloseLine />
                  )}
                </div>
              </div>
              <div className="form-inner-div">
                <CustomInput
                  label="Confirm Password"
                  type={isActive.confirmPassword ? "text" : "password"}
                  placeholder="Confirm Password"
                  name="confirmPassword"
                  value={values.confirmPassword}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.confirmPassword}
                  touched={touched.confirmPassword}
                />
                <div
                  onClick={() => handlePasswordVisible("confirmPassword")}
                  className="password-eye"
                >
                  {isActive.confirmPassword ? (
                    <RiEyeCloseLine />
                  ) : (
                    <MdOutlineRemoveRedEye />
                  )}
                </div>
              </div>
            </div>
            <button disabled={isLoadingResetPassword}>
              {isLoadingResetPassword ? (
                <ClipLoader size={17} color="#fff" />
              ) : (
                "Save"
              )}
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default ResetPassword;
